import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const textEffectsOutlineOutSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'bevel-angle': {
    type: 'CSSString',
    defaultValue: '0deg',
  },
  'layer-blend-mode': {
    type: 'CSSString',
    defaultValue: 'normal',
  },
} as const satisfies SiteAssetsSkinParams;

const textEffectsOutlineOutSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsOutlineOut': textEffectsOutlineOutSkin,
};

export default generateSkinDefaults(textEffectsOutlineOutSkinDefinitionMap);
